/* istanbul ignore file */

import type { FocusEvent, Ref } from 'react';
import React from 'react';
import type { InputFieldProps } from '@noths/polaris-client-ribbons-design-system';
import { InputField } from '@noths/polaris-client-ribbons-design-system';

import { useTracking } from 'src/hooks/useTracking/useTracking';

export interface TextInputProps extends InputFieldProps {
  'data-position'?: string;
  'data-section'?: string;
}

export const TextInput = React.forwardRef((props: TextInputProps, ref: Ref<HTMLInputElement>) => {
  const { trackCompleted, trackFocusOnce } = useTracking();
  const { onBlur: delegatedOnBlur, onFocus: delegatedOnFocus } = props;

  const onFocus = (event: FocusEvent<HTMLInputElement>) => {
    trackFocusOnce(event);

    if (delegatedOnFocus) {
      delegatedOnFocus(event);
    }
  };

  const onBlur = (event: FocusEvent<HTMLInputElement>) => {
    trackCompleted(event);

    if (delegatedOnBlur) {
      delegatedOnBlur(event);
    }
  };

  return <InputField ref={ref} {...props} onBlur={onBlur} onFocus={onFocus} />;
});
